export default __webpack_public_path__ + "static/media/objetivos_ENG-movil.48345ef4.png";